export default __webpack_public_path__ + "static/media/Coins.b9aed7d8.svg";